export default __webpack_public_path__ + "static/media/facebook.94f676e8.jpg";